export default __webpack_public_path__ + "static/media/gmall-logo.94682a65.png";